import React, { useEffect } from "react";
import Title from "../../new-components/title/Title";
import { Link, useLocation, useParams } from "react-router-dom";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";
import NewFooter from "../../NewFooter";
import "../food-and-beverages/FoodAndBeverages.scss";
import redTagImage from "../../../src/assets/images/Badgex0.5.png";
import ITImage from "../../assets/new_imgs/ITImage.png";
import { trackCategoryViewed } from "../../utils/mixpanel";
import housekeepingImage from "../../assets/new_imgs/Housekeeping.png";
import receptionImage from "../../assets/new_imgs/Reception.png";
import laundryImage from "../../assets/new_imgs/Laundry.png";

const HotelServices = () => {
  const params = useParams();
  const lang = localStorage.getItem("lang");
  const location = useLocation();
  const metadata = location.state?.metadata;
  const countryCode = localStorage.getItem("countryCode");
  const isSaudi = countryCode?.toUpperCase() === "SA";
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  console.log("metadata", metadata);

  return (
    <div className={`food ${lang === "AR" && "arabic"}`}>
      <Title title={"Hotel Services"} />

      <div className="box_food image_services">
        {metadata?.map((service) => {
          // if (service.id === 18) {
          //   return (
          //     <Link to={`/${params.room_uuid}/hotel-services/salon`}>
          //       <img
          //         src={"https://d3l5wxnahfuscp.cloudfront.net/static/salon.png"}
          //         alt=""
          //         className="service_img"
          //       />
          //       <img src={Overllay} alt="" className="overlay" />
          //       <h6 className="sub_title">{service?.display_name}</h6>
          //     </Link>
          //   );
          // }

          if (service.id === 3) {
            console.log("test", service);
            const isClosed = !!service.is_closed;
            const cardContent = (
              <>
                {isClosed && (
                  <div
                    style={{
                      position: "absolute",
                      top: 8,
                      left: 0,
                      width: 88,
                      height: 36,
                      backgroundImage: `url(${redTagImage})`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 5,
                      pointerEvents: "none",
                    }}
                  >
                    <span
                      style={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: 12,
                        textTransform: "uppercase",
                        lineHeight: 1,
                      }}
                    >
                      Closed
                    </span>
                  </div>
                )}
                <img
                  src={
                    isSaudi
                      ? laundryImage
                      : `https://d3l5wxnahfuscp.cloudfront.net/static/Laundry.png`
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </>
            );
            if (isClosed) {
              return (
                <div
                  style={{
                    position: "relative",
                    cursor: "not-allowed",
                    opacity: 0.85,
                  }}
                  aria-disabled="true"
                  tabIndex={-1}
                >
                  {cardContent}
                </div>
              );
            }
            return (
              <Link
                to={`/${params.room_uuid}/hotel-services/laundry/${
                  service.link.split(`${params.room_uuid}/laundry/`)[1]
                }`}
                style={{ position: "relative" }}
                onClick={() =>
                  trackCategoryViewed({
                    category_id: 3,
                    category_name: service?.display_name || "",
                    category_type: "Laundry",
                  })
                }
              >
                {cardContent}
              </Link>
            );
          }
          if (service.id === 5) {
            const isClosed = !!service.is_closed;
            const cardContent = (
              <>
                {isClosed && (
                  <div
                    style={{
                      position: "absolute",
                      top: 8,
                      left: 0,
                      width: 88,
                      height: 36,
                      backgroundImage: `url(${redTagImage})`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 5,
                      pointerEvents: "none",
                    }}
                  >
                    <span
                      style={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: 12,
                        textTransform: "uppercase",
                        lineHeight: 1,
                      }}
                    >
                      Closed
                    </span>
                  </div>
                )}
                <img
                  src={
                    isSaudi
                      ? housekeepingImage
                      : `https://d3l5wxnahfuscp.cloudfront.net/static/Housekeeping.png`
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </>
            );
            if (isClosed) {
              return (
                <div
                  style={{
                    position: "relative",
                    cursor: "not-allowed",
                    opacity: 0.85,
                  }}
                  aria-disabled="true"
                  tabIndex={-1}
                >
                  {cardContent}
                </div>
              );
            }
            return (
              <Link
                to={`/${params.room_uuid}/hotel-services/houseKeeping`}
                style={{ position: "relative" }}
                onClick={() =>
                  trackCategoryViewed({
                    category_id: 5,
                    category_name: service?.display_name || "",
                    category_type: "Housekeeping",
                  })
                }
              >
                {cardContent}
              </Link>
            );
          }
          if (service.id === 15) {
            const isClosed = !!service.is_closed;
            const cardContent = (
              <>
                {isClosed && (
                  <div
                    style={{
                      position: "absolute",
                      top: 8,
                      left: 0,
                      width: 88,
                      height: 36,
                      backgroundImage: `url(${redTagImage})`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 5,
                      pointerEvents: "none",
                    }}
                  >
                    <span
                      style={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: 12,
                        textTransform: "uppercase",
                        lineHeight: 1,
                      }}
                    >
                      Closed
                    </span>
                  </div>
                )}
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/Maintenance.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </>
            );
            if (isClosed) {
              return (
                <div
                  style={{
                    position: "relative",
                    cursor: "not-allowed",
                    opacity: 0.85,
                  }}
                  aria-disabled="true"
                  tabIndex={-1}
                >
                  {cardContent}
                </div>
              );
            }
            return (
              <Link
                to={`/${params.room_uuid}/maintenance/companies`}
                style={{ position: "relative" }}
                onClick={() =>
                  trackCategoryViewed({
                    category_id: 15,
                    category_name: service?.display_name || "",
                    category_type: "Maintenance",
                  })
                }
              >
                {cardContent}
              </Link>
            );
          }
          if (service.id === 36) {
            const isClosed = !!service.is_closed;
            const cardContent = (
              <>
                {isClosed && (
                  <div
                    style={{
                      position: "absolute",
                      top: 8,
                      left: 0,
                      width: 88,
                      height: 36,
                      backgroundImage: `url(${redTagImage})`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 5,
                      pointerEvents: "none",
                    }}
                  >
                    <span
                      style={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: 12,
                        textTransform: "uppercase",
                        lineHeight: 1,
                      }}
                    >
                      Closed
                    </span>
                  </div>
                )}
                <img
                  src={
                    // ITImage
                    "https://d3l5wxnahfuscp.cloudfront.net/static/IT.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </>
            );
            if (isClosed) {
              return (
                <div
                  style={{
                    position: "relative",
                    cursor: "not-allowed",
                    opacity: 0.85,
                  }}
                  aria-disabled="true"
                  tabIndex={-1}
                >
                  {cardContent}
                </div>
              );
            }
            return (
              <Link
                to={`/${params.room_uuid}/it/companies`}
                style={{ position: "relative" }}
                onClick={() =>
                  trackCategoryViewed({
                    category_id: 36,
                    category_name: service?.display_name || "",
                    category_type: "IT",
                  })
                }
              >
                {cardContent}
              </Link>
            );
          }
          if (service.id === 7) {
            const isClosed = !!service.is_closed;
            const cardContent = (
              <>
                {isClosed && (
                  <div
                    style={{
                      position: "absolute",
                      top: 8,
                      left: 0,
                      width: 88,
                      height: 36,
                      backgroundImage: `url(${redTagImage})`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 5,
                      pointerEvents: "none",
                    }}
                  >
                    <span
                      style={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: 12,
                        textTransform: "uppercase",
                        lineHeight: 1,
                      }}
                    >
                      Closed
                    </span>
                  </div>
                )}
                <img
                  src={
                    isSaudi
                      ? receptionImage
                      : "https://d3l5wxnahfuscp.cloudfront.net/static/Conceirge.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </>
            );
            if (isClosed) {
              return (
                <div
                  style={{
                    position: "relative",
                    cursor: "not-allowed",
                    opacity: 0.85,
                  }}
                  aria-disabled="true"
                  tabIndex={-1}
                >
                  {cardContent}
                </div>
              );
            }
            return (
              <Link
                to={`/${params.room_uuid}/hotel-services/conceirge`}
                style={{ position: "relative" }}
                onClick={() =>
                  trackCategoryViewed({
                    category_id: 7,
                    category_name: service?.display_name || "",
                    category_type: "Concierge",
                  })
                }
              >
                {cardContent}
              </Link>
            );
          }
        })}
      </div>
      <NewFooter />
    </div>
  );
};

export default HotelServices;
